<div class="toast-container">
  <div *ngFor="let toast of toasts" class="toast" [ngClass]="'toast-' + toast.type" (click)="removeToast(toast)">

    <div class="toast-icon">
      <i *ngIf="toast.type === 'success'" class="fas fa-check-circle"></i>
      <i *ngIf="toast.type === 'error'" class="fas fa-times-circle"></i>
      <i *ngIf="toast.type === 'info'" class="fas fa-info-circle"></i>
      <i *ngIf="toast.type === 'warning'" class="fas fa-exclamation-triangle"></i>
    </div>

    <div class="toast-message">
      {{ toast.message }}
    </div>

  </div>
</div>